exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-dialog[data-v-32ff4f7d]{min-width:320px;padding:4px}.buttons[data-v-32ff4f7d]{margin-top:16px;text-align:right}.form[data-v-32ff4f7d]{margin-bottom:20px}.field[data-v-32ff4f7d]{width:100%}.fields .field[data-v-32ff4f7d]:first-child{padding-left:0px}.fields .field[data-v-32ff4f7d]:last-child{padding-right:0px}.ui.form .fields[data-v-32ff4f7d]{margin-left:0;margin-right:0}.content[data-v-32ff4f7d]{overflow:hidden}", ""]);

// exports
